import { SalesOrderLine } from './sales-order-line';

export interface SalesContractLineDetails {
  id: string;
  contractNo: number;
  customerKey: string;
  customerName: string;
  currency: string;
  description: string;
  productId: string;
  productKey: string;
  productTypeDescription: string;
  productDescription: string;
  unitOfMeasure: string;
  unitOfMeasureId: string;
  quantity: number;
  price: number;
  contractValue: number;
  contractBalance: number;
  contractBalanceValue: number;

  salesOrderLines: SalesOrderLine[];
}
